import React, { ChangeEvent } from 'react';

import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { type FieldProps } from 'formik';
import { Translate } from 'react-localize-redux';

import { formikValidate } from '../../../../../helpers/validation';
import FormItem from '../FormItem';

const intervalValidation = (value: number) => {
  const min = 5;
  const max = 1440;

  return (
    formikValidate.required(value) ||
    formikValidate.digits(value) ||
    formikValidate.max(max)(value) ||
    formikValidate.min(min)(value)
  );
};

type Props = {
  canEdit: boolean;
  hasPeriods: boolean;
};

const IntervalMinutes = ({ canEdit, hasPeriods }: Props) => {
  return (
    <FormItem
      divider
      primary={<Translate id="Interval" />}
      secondary={<Translate id="Preorder_settings_interval_item_helper_text" />}
      name="IntervalMinutes"
      validate={intervalValidation}
    >
      {({ field, form }: FieldProps) => {
        const { errors, touched } = form;
        const fieldError = errors[field.name] as string | undefined;
        const showError = !!fieldError && (touched[field.name] as boolean | undefined);

        return (
          <TextField
            variant="standard"
            fullWidth
            disabled={!canEdit}
            value={field.value}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              form.setFieldValue(field.name, e.target.value);
            }}
            error={showError}
            helperText={
              showError ? (
                fieldError
              ) : hasPeriods ? (
                <Translate id="Changing_this_value_will_automatically_update_your_order" />
              ) : undefined
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                  <Translate id="mins" />
                </InputAdornment>
              ),
            }}
            inputProps={{ maxLength: 4, 'data-fd': 'pre_order_settings_interval_minutes' }}
          />
        );
      }}
    </FormItem>
  );
};

export default IntervalMinutes;
